import React, { useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSync } from "@fortawesome/free-solid-svg-icons";
import { useHistory, useParams } from "react-router-dom";
import { SettingsContext } from "../../../contexts";
import { UserContext } from "../../../contexts";

const Trigger = ({ item }) => {
  const history = useHistory();
  const params = useParams();
  const settings = useContext(SettingsContext);
  const { user } = useContext(UserContext);

  let stats = item.quotes?.reduce((acc, quote) => {
    acc[quote.status] = acc[quote.status] + 1 || 1;

    return acc;
  }, {});

  let color = "black";
  if (stats) {
    if (!stats["created"] && !stats["to_review"] && item.quotes?.length > 0) {
      color = "green";
    } else if (stats["to_review"] > 0) {
      color = "orange";
    }
  }

  const handleSyncListing = (e) => {
    e.stopPropagation();
    if (item.orderPrimaryListing) {
      history.push(`/product/${item.orderPrimaryListing}`);
    } else {
      history.push(
        `/${history.location.pathname
          .split("/")
          .slice(1, 3)
          .join("/")}/${params.requestId}/select-listing?${
          settings.iframeQueryParams
        }`
      );
    }
  };

  // Safely check if orderListing exists and has items
  const hasOrderListings = Array.isArray(item.orderListing) && item.orderListing.length > 0;

  return (
    <div className="trigger">
      Quotes
      <div className={`dot ${color}`} />
      <div className="status-label d-flex">
        {hasOrderListings && (
          <button
            className="mx-3 sync-quote-btn"
            onClick={(e) => handleSyncListing(e)}
          >
            <FontAwesomeIcon
              icon={faSync}
              size="sm"
              className={`${
                item.orderPrimaryListing ? "text-success" : "text-danger"
              }`}
            />
          </button>
        )}

      </div>
    </div>
  );
};

export default Trigger;
